/**
 * 環境配置管理
 * 根據環境變數自動加載對應配置
 */

export const env = {
  // 環境類型
  mode: import.meta.env.MODE || 'development',
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
  
  // API 配置
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3001',
  convexUrl: import.meta.env.VITE_CONVEX_URL || '',
  
  // Supabase 配置
  // 根據環境自動切換（development/staging/production）
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL || '',
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || '',
  supabaseServiceRoleKey: import.meta.env.VITE_SUPABASE_SERVICE_ROLE_KEY || '',
  
  // 環境標識（用於調試和日誌）
  environment: import.meta.env.MODE || 'development', // development, staging, production
  
  // WalletConnect 配置
  walletConnectProjectId: import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || '3a149608af607755b30348f0833d5f6c',
  
  // 區塊鏈配置
  chainId: parseInt(import.meta.env.VITE_CHAIN_ID || '56'), // BSC Mainnet
  rpcUrl: import.meta.env.VITE_RPC_URL || 'https://bsc-dataseed1.binance.org',
  usdcAddress: import.meta.env.VITE_USDC_ADDRESS || '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d', // BSC Mainnet USDC
  multisigAddress: import.meta.env.VITE_MULTISIG_ADDRESS || '',
  multiSendAddress: import.meta.env.VITE_MULTISEND_ADDRESS || '0xe2a9cf7064cE4CeB6a076649822C7B62B5D4B085', // MultiSend 合約
  
  // Polymarket 配置
  polymarketApiUrl: import.meta.env.VITE_POLYMARKET_API_URL || 'https://gamma-api.polymarket.com',
  polymarketProxy: import.meta.env.VITE_POLYMARKET_PROXY || 'http://localhost:3001/api/gamma',
  
  // 功能開關
  enableDebug: import.meta.env.VITE_ENABLE_DEBUG === 'true',
  enableMockData: import.meta.env.VITE_ENABLE_MOCK_DATA === 'true',
  
  // 監控和分析
  sentryDsn: import.meta.env.VITE_SENTRY_DSN || '',
  analyticsId: import.meta.env.VITE_ANALYTICS_ID || '',
  gaMeasurementId: import.meta.env.VITE_GA_MEASUREMENT_ID || '', // Google Analytics 4 Measurement ID
}

// 環境驗證
// 注意：多簽錢包地址驗證已移除，因為目前尚未開始區塊鏈測試
// 當需要區塊鏈功能時，可以在相關組件中進行驗證

// 開發環境調試信息（延遲加載 logger）
if (env.enableDebug || env.isDev) {
  import('../utils/logger.js').then(({ logger }) => {
    logger.log('🔧 環境配置:', {
      mode: env.mode,
      environment: env.environment,
      chainId: env.chainId,
      apiUrl: env.apiUrl,
      supabaseConfigured: !!(env.supabaseUrl && env.supabaseAnonKey),
      isDev: env.isDev,
      isProd: env.isProd,
    })
    
    // Supabase 配置警告
    if (!env.supabaseUrl || !env.supabaseAnonKey) {
      logger.warn('⚠️ Supabase 配置未設置，請檢查環境變數')
    } else {
      logger.log('✅ Supabase 配置已設置')
    }
  }).catch(() => {
    // 如果 logger 加載失敗，靜默處理（生產環境）
  })
}

